import React, { useState, useEffect, useRef } from "react";
import { Box, Typography, Grid, Tooltip } from "@mui/material";
import {
  getPacDetails,
  uploadFileImage,
  updateTicket,
  downloadFile,
  multipleDownloadFile,
  getRolesData,
  createIntellectTicket,
  intellectTicketReopen,
  memberUpload,
  getSeverity,
} from "../apiSection/apiUrlConstent";
import service from "../apiSection/service";
import { ShowAlert } from "../Common/Components/Alert";
import Loading from "../Common/Components/Loading";
import CustomRadio from "../Common/Components/RadioButton";
import { useForm } from "react-hook-form";
import TextArea from "../Common/Components/TextArea";
import Input from "../Common/Components/InputField";
import ErrorMessage from "../Common/Components/ErrorMessage";
import ActionButton from "../Common/Components/Button";
import CustomSelect from "../Common/Components/Select";
import { makeStyles } from "@mui/styles";
import ArrowDownwardIcon from "@mui/icons-material/FileDownload";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const useStyles = makeStyles(() => ({
  heading: {
    background: "#707EAE26",
    padding: "15px",
    borderRadius: "8px",
  },
  cardsData: {
    background: "white",
  },
  cardUserData: {
    backgroundColor: "#F5F8FF",
    padding: "20px",
    borderRadius: "8px",
    marginLeft: "13px",
  },
  cardUserDetails: {
    backgroundColor: "#F5F8FF",
    borderRadius: "8px",
  },
  userDatamap: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  userDatalabel: {
    color: "#707EAE",
    wordWrap: "break-word",
    maxWidth: "200px",
    fontSize: "15px",
    whiteSpace: "normal",
  },
  uploadLabel: {
    color: "blue",
    wordWrap: "break-word",
    maxWidth: "250px",
    fontSize: "15px",
    whiteSpace: "normal",
    textDecoration: "underline", // Adds underline
    textDecorationColor: "blue",
    cursor: "pointer",
  },
  uploadValue: {
    color: "#000",
    wordWrap: "break-word",
    maxWidth: "250px",
    fontSize: "15px",
    whiteSpace: "normal",
  },
  cardPacData: {
    backgroundColor: "#F5F8FF",
    padding: "20px",
    borderRadius: "8px",
  },
  cardPacDetails: {
    backgroundColor: "#F5F8FF",
    borderRadius: "8px",
  },
  cardPacMap: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  cardPacMapValue: {
    color: "#000",
    maxWidth: "80%",
    fontSize: "15px",
  },
  cardPacstatus: {
    color: "black",
    marginTop: "5px",
  },
  ticketStatus: {
    borderRadius: "8px",
    marginTop: "10px",
    paddingLeft: "70px",
  },
  uplaods: {
    color: "#707EAE",
    padding: "10px",
    fontSize: "16px",
  },
  boxCustomRadio: {
    gap: 4,
    backgroundColor: "#F5F8FF",
    padding: "5px ",
    borderRadius: "5px",
    // height: "100%",
  },
  boxCustomRadio1: {
    gap: 4,
    // backgroundColor: "#F5F8FF",
    marginTop: "10px",
    padding: "5px ",
  },
  userDataRole: {
    color: "#707EAE",
    padding: "10px 0px",
    fontSize: "15px",
  },
  uploadGrid: {
    backgroundColor: "#F5F8FF",
    borderRadius: "8px",
  },
  uploadAttachment: {
    color: "#707EAE",
    padding: "10px",
    fontSize: "15px",
  },
  updateButton: {
    float: "right",
    marginTop: "10px",
    padding: "10px",
  },
}));
function IssueDetails(props) {
  const [loading, setLoading] = useState("");
  const [pacsData, setPacsData] = useState("");
  const [fileData, setFileData] = useState([]);
  const [severityData, setSeverityData] = useState([]);
  const classes = useStyles();
  const allowedRoles = [1, 2, 3, 4, 5, 6, 7, 8, 11, 12, 14];
  let pacsDataId = props.rowData.pac_id;
  const {
    register,
    handleSubmit,
    control,
    clearErrors,
    resetField,
    setValue,
    formState: { errors },
  } = useForm();

  const [status, setStatus] = React.useState(null);
  const [assignedList, setAssignedList] = React.useState([]);
  const handleChangeStatus = (e) => {
    setStatus(e.target.value);
    scrollToDiv();
    if (e.target.value == 7) {
      // setTimeout(()=>{
      if (filename && base64String) {
        setDisableBtn(1);
        handleConvertAndSetFile();
      }
      //},1000)
    }
  };

  const handlePacDetails = (data) => {
    setLoading(true);
    const postData = {
      search_id: pacsDataId,
      // flag: props.rowData.severity_flag
    };
    service
      .create(getPacDetails, postData)
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          setPacsData(res.data.result);
        }
      })
      .catch((error) => {
        setLoading(false);
        // ShowAlert({
        //   icon: "error",
        //   text: error.response.data.message,
        //   width: "400px",
        // });
      });
  };
  useEffect(() => {
    handlePacDetails();
    getROlesListData();
    getFileDetails();

    const severityObject = severityData?.find((item) => {
      const itemSeverityDesc = item?.severity_desc?.toUpperCase()?.trim();
      const rowSeverityDesc = props?.rowData?.severity_desc
        ?.toUpperCase()
        ?.trim();

      return itemSeverityDesc === rowSeverityDesc;
    });

    if (severityObject) {
      setValue("severity", severityObject.severity_id);
    } else {
      // setValue("severity", null);
      console.warn(`Unknown severity: ${props?.rowData?.severity_desc}`);
    }
  }, [props?.rowData?.severity_desc, severityData]);

  const handleUploadFile = (e) => {
    const files = Array.from(e.target.files); // Convert FileList to an array
    const allowedExtensions =
      status == 7
        ? ["zip", "jpg", "jpeg", "png", "pdf", "docx", "doc", "xlsx", "xls"]
        : ["jpg", "jpeg", "png", "pdf", "docx", "doc", "xlsx", "xls", "zip"];
    const maxSize = 1024 * 1024; // 1MB in bytes
    let validFiles = [];
    let errorMessages = [];

    files.forEach((file) => {
      const fileExtension = file.name.split(".").pop().toLowerCase();

      // Validate file extension
      if (!allowedExtensions.includes(fileExtension)) {
        errorMessages.push(`Invalid file type: ${file.name}`);
        e.target.value = null;
        return;
      }

      // Validate file size
      if (file.size > maxSize) {
        errorMessages.push(`File size exceeds 1MB limit: ${file.name}`);
        e.target.value = null;
        return;
      }

      // Add valid file to the array
      validFiles.push(file);
    });

    // Show error messages if there are invalid files
    if (errorMessages.length > 0) {
      ShowAlert({
        icon: "error",
        text: errorMessages.join("\n"),
        width: "400px",
      });
    }

    // Update state with valid files
    if (validFiles.length > 0) {
      setFileData(validFiles); // Update your state or handle valid files
    } else {
      setFileData([]); // Clear the state if no valid files
      e.target.value = "";
    }

    // Clear the file input
  };
  const StatusList =
    props.userData &&
    (props.userData.role_id === 1 || props.userData.role_id === 2)
      ? props.rowData && props.rowData.status_dec === "Resolved"
        ? [
            { id: 3, label: "Close" },
            { id: 8, label: "Reopen" },
          ]
        : []
      : props.userData && props.userData.role_id === 3 
      ? [
        { id: 2, label: "Resolved" },
        { id: 4, label: "Reassign" },
        props.rowData &&
        props.rowData.status_dec !== "Open" && props.rowData.status_dec !== "Resolved-Intellect" && props.rowData.status_dec !== "Reopen"
          ? props.rowData.intellect_ticket_no === "Not Assigned"
            ? { id: 7, label: "Intellect" }
            : { id: 10, label: "Reopen Intellect" }
          : null,
        ].filter(Boolean) 
      : [
          { id: 2, label: "Resolved"},
          { id: 4, label: "Reassign"},
        ];

  function getFileNameAndExtension(fileName) {
    const dotIndex = fileName.lastIndexOf(".");

    return {
      name: dotIndex !== -1 ? fileName.substring(0, dotIndex) : fileName,
      extension:
        dotIndex !== -1 ? fileName.substring(dotIndex + 1).toLowerCase() : "",
    };
  }
  function toBase64Unicode(str) {
    return btoa(unescape(encodeURIComponent(str))); // Convert to Base64 with Unicode support
  }

  const handleUpdateStatus = async (data) => {
    try {
      setLoading(true);
      if (Number(status) === 7) {
        const formData = new FormData();
        if (fileData && fileData[0]) {
          formData.append("attachment", fileData[0]);
          console.log("File from fileData:", fileData[0]);
        } else if (fileInputRef?.current?.files?.length) {
          const inputElement = fileInputRef.current;
          formData.append("attachment", inputElement.files[0]);
          console.log("File from fileInputRef:", inputElement.files[0]);
        }

        formData.append("tckt_id", props.rowData.tckt_id);
        formData.append("reason", data.reason || props.rowData.reason);
        formData.append("status", Number(status));

        const response = await service.create(
          createIntellectTicket,
          formData,
          "res"
        );
        setLoading(false);

        if (response.status === 200) {
          ShowAlert({
            icon: "success",
            text: "Ticket assigned to Intellect Successfully",
            width: "400px",
            confirmAction: () => props.handleClose(),
          });
        }
      } else {
        let uploadedFiles = [];

        // File upload logic
        if (fileData?.length > 0) {
          const uploadPromises = fileData.map((file) => {
            const formData = new FormData();
            formData.append("requestid", "23576598");
            formData.append("file", file);
            formData.append("requesttype", "File Uploads");
            formData.append("requestsrc", "ui");
            formData.append("status", "ui");
            return service.uploadFile(uploadFileImage, formData);
          });

          const uploadResponses = await Promise.all(uploadPromises);

          // uploadedFiles = uploadResponses.map((res) => {
          //   const { name, extension } = getFileNameAndExtension(
          //     res.data.result.name
          //   );
          //   return {
          //     path: res.data.result.path,
          //     name: name.replace(/ /g, "_"), // Replace spaces with underscores
          //     extension,
          //   };
          // });

          uploadedFiles = uploadResponses.map((res) => {
            const result = res.data.result;
            return {
              path: result.nextcloud_path,        // attachment
              name: result.storage_filename,      // filename
              extension: result.debug_extension,  // file_extension
            };
          });
        }
        // Encode uploaded file details
        const encodedFiles = toBase64Unicode(JSON.stringify(uploadedFiles));
        const encodedFileNames = toBase64Unicode(
          JSON.stringify(
            uploadedFiles.map((file) => file.name.replace(/ /g, "_"))
          )
        );
        const encodedFileExtensions = toBase64Unicode(
          JSON.stringify(uploadedFiles.map((file) => file.extension))
        );

        const postData = {
          tkt_id: props.rowData.tckt_id,
          reason: data.reason || props.rowData.reason,
          status: Number(status),
          assigned_to: data.assgnedTO || null,
          // attachment:
          //   uploadedFiles.length > 0
          //     ? encodedFiles
          //     : props.rowData.updated_attachment,
          // filename:
          //   uploadedFiles.length > 0
          //     ? encodedFileNames
          //     : props.rowData.updated_file_name,
          // file_extension:
          //   uploadedFiles.length > 0
          //     ? encodedFileExtensions
          //     : props.rowData.updated_file_extension,

          attachment:
            uploadedFiles.length > 0
              ? uploadedFiles.map((f) => f.path).join(",") // if multiple, join
              : props.rowData.updated_attachment,

          filename:
            uploadedFiles.length > 0
              ? uploadedFiles.map((f) => f.name).join(",")
              : props.rowData.updated_file_name,

          file_extension:
            uploadedFiles.length > 0
              ? uploadedFiles.map((f) => f.extension).join(",")
              : props.rowData.updated_file_extension,


          flag: data?.severity ? "active" : "inactive",
          severity: data?.severity,
        };

        const response = await service.create(
          (Number(status) === 10)  && props?.rowData?.intellect_id !== null
            ? intellectTicketReopen
            : updateTicket,
          postData
        );
        // const response = await service.create(updateTicket, postData);
        setLoading(false);

        if (response.status === 200) {
          ShowAlert({
            icon: "success",
            text: response.data.message,
            width: "400px",
            confirmAction: () => {
              props.handleClose();
              setFileData([]);
            },
          });
        }
      }
    } catch (error) {
      setLoading(false);
      console.error(error);

      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while processing your request.";

      ShowAlert({
        icon: "error",
        text: errorMessage,
        width: "400px",
      });

      setPacsData("");
    }
  };
  const handleDownload = (data, key) => {
    setLoading(true);
    const downloadFiles = (attachmentPath) => {
      const postData = { path: attachmentPath };
      service
        .create(multipleDownloadFile, postData)
        .then((res) => {
          setLoading(false);
          if (res.status === 200 && res.data.result.file_url) {
            window.open(res.data.result.file_url, "__blank");
          } else if (
            res.status === 200 &&
            res.data.result.flag &&
            res.data.result.flag === true
          ) {
            const file_data = res.data.result;

            if (!file_data || !file_data.base64 || !file_data.extension) {
              console.error("Invalid file data received.");
              return;
            }

            const data = {
              file_extension: file_data.extension,
              file_name:
                file_data.file_name && file_data.file_name.trim() !== ""
                  ? file_data.file_name
                  : props.rowData.file_name
                  ? props.rowData.file_name
                  : "download",
            };

            const mimeType =
              mimeTypes[data.file_extension.toLowerCase()] ||
              "application/octet-stream";

            // Use Blob for better handling of file data
            const link = document.createElement("a");
            link.href = `data:${mimeType};base64,${file_data.base64}`;
            link.download = `${data.file_name}.${data.file_extension}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch((error) => {
          setLoading(false);
          ShowAlert({
            icon: "error",
            text: error.response?.data?.message || "Failed to download file.",
            width: "400px",
          });
        });
    };
    const handleFileDownload = (attachmentDataKey) => {
      const decryptedData = data[attachmentDataKey];
      if (decryptedData && decryptedData !== "" && decryptedData !== null) {
        downloadFiles(decryptedData);
      } else {
        setLoading(false);
        ShowAlert({
          icon: "error",
          text: "No files available for download.",
          width: "400px",
        });
      }
    };
    if (key === "createDownload") {
      handleFileDownload("attachment");
    } else if (key === "updateDownload") {
      handleFileDownload("updated_attachment");
    }
  };
  // MIME types
  const mimeTypes = {
    pdf: "application/pdf",
    pdf: "application/zip",
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    txt: "text/plain",
    csv: "text/csv",
    json: "application/json",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    png: "image/png",
    jpeg: "image/jpeg",
    jpg: "image/jpeg",
    gif: "image/gif",
    pdf: "application/pdf",
    txt: "text/plain",
    html: "text/html",
    css: "text/css",
    js: "application/javascript",
    json: "application/json",
    xml: "application/xml",
    csv: "text/csv",
    zip: "application/zip",
    tar: "application/x-tar",
    mp4: "video/mp4",
    mov: "video/quicktime",
    avi: "video/x-msvideo",
    mkv: "video/x-matroska",
    mp3: "audio/mpeg",
    wav: "audio/wav",
    ogg: "audio/ogg",
    webm: "video/webm",
    flv: "video/x-flv",
    svg: "image/svg+xml",
    bmp: "image/bmp",
    tiff: "image/tiff",
    ico: "image/x-icon",
    wmv: "video/x-ms-wmv",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    jsonld: "application/ld+json",
    eot: "application/vnd.ms-fontobject",
    otf: "font/otf",
    ttf: "font/ttf",
    woff: "font/woff",
    woff2: "font/woff2",
    mpkg: "application/vnd.apple.installer+xml",
    xul: "application/vnd.mozilla.xul+xml",
    eps: "application/postscript",
    ai: "application/postscript",
    psd: "image/vnd.adobe.photoshop",
    ics: "text/calendar",
    key: "application/vnd.apple.keynote",
    rar: "application/x-rar-compressed",
    "7z": "application/x-7z-compressed",
    webp: "image/webp",
    flac: "audio/flac",
    m4a: "audio/mp4",
    m4v: "video/x-m4v",
    oga: "audio/ogg",
    oga: "audio/ogg",
    ogv: "video/ogg",
  };

  const getROlesListData = () => {
    service
      .get(getRolesData)
      .then((res) => {
        setLoading(false);
        setAssignedList(res.data.result.user_roles);
      })
      .catch((error) => {
        setLoading(false);
        ShowAlert({
          icon: "error",
          text: error.response.data.message,
          width: "400px",
        });
      });
  };
  function formatDate(inputDate) {
    const date = new Date(inputDate);

    // Extract day, month, and year
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    // Return in desired format
    return `${day}/${month}/${year}`;
  }

  const targetDivRef = useRef(null);

  const scrollToDiv = () => {
    setTimeout(() => {
      if (targetDivRef.current) {
        targetDivRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 1000);
  };

  //dynamic file object
  const [filename, setFilename] = useState("");
  const [base64String, setBase64String] = useState("");
  const fileInputRef = useRef(null);
  const getMimeTypeFromExtension = (extension) => {
    return mimeTypes[extension.toLowerCase()] || "application/octet-stream"; // Default MIME type
  };

  const base64ToFile = () => {
    return new Promise((resolve) => {
      const extension = filename.split(".").pop();
      const mimeType = getMimeTypeFromExtension(extension);

      const byteCharacters = atob(base64String);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }

      const blob = new Blob(byteArrays, { type: mimeType });
      resolve(new File([blob], filename, { type: mimeType }));
    });
  };

  // Convert base64 to file and assign it to input
  const [disableBtn, setDisableBtn] = useState(0);
  const handleConvertAndSetFile = async () => {
    const file = await base64ToFile(); // Use the filename to determine MIME type

    // Ensure the file input is properly referenced

    if (fileInputRef.current) {
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      fileInputRef.current.files = dataTransfer.files;
    }

    setDisableBtn(0);
  };

  const getFileDetails = () => {
    const postData = {
      tckt_id: props.rowData.tckt_id,
    };
    service
      .create(memberUpload, postData)
      .then((res) => {
        console.log("memberattachment", res);
        setLoading(false);
        if (
          res?.data?.result?.filename != null &&
          res?.data?.result?.filename != "null" &&
          res?.data?.result?.extension != null &&
          res?.data?.result?.extension != "null"
        ) {
          setFilename(
            res.data.result.filename + "." + res.data.result.extension
          );
          setBase64String(res.data.result.base64);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (base64String && filename) {
      setDisableBtn(1);
      handleConvertAndSetFile();
    }
  }, [base64String, filename]);

  useEffect(() => {
    clearErrors();
    resetField("uploadImage");
    setDisableBtn(1);
    handleConvertAndSetFile();
    handleSeverity();
  }, [status]);

  const handleSeverity = () => {
    setLoading(true);
    service
      .get(getSeverity)
      .then((res) => {
        setLoading(false);
        setSeverityData(res.data.result);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  {
    console.log("role_id:", props?.userData?.role_id);
  }
  console.log("tckt_status:", props.rowData.tckt_status);
  console.log(
    "includes result:",
    ![3, 7, 9].includes(props.rowData.tckt_status)
  );
  console.log(
    "role check:",
    props.userData.role_id === 1 || props.userData.role_id === 2
  );
  console.log("status check:", props.rowData.tckt_status === 4);
  return (
    <Box
      sx={{
        margin: "auto",
      }}
    >
      <Loading open={loading} />
      <div className={classes.heading}>
        <Typography variant="body2" color="text.secondary">
          Created Date{" "}
          <span style={{ fontWeight: 600 }}>
            {formatDate(props?.rowData?.created_on)}
          </span>
          <span style={{ marginLeft: "20px" }}>
            Closed Date{" "}
            {props?.rowData?.tckt_status === 3 ? (
              <span style={{ fontWeight: 600 }}>
                {formatDate(props?.rowData?.modified_on)}
              </span>
            ) : (
              ""
            )}
          </span>
        </Typography>
      </div>
      <Grid
        container
        spacing={2}
        className={classes.cardsData}
        style={{ margin: "10px 0px 0px 7px", padding: "10px" }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          xl={6}
          className={classes.cardUserData}
        >
          <div className={classes.cardUserDetails}>
            {[
              { label: "Subject", value: props.rowData?.sub_desc || "-" },
              {
                label: "Department Type",
                value: props.rowData?.department_desc || "-",
              },
              { label: "Module", value: props.rowData?.module_desc || "-" },
              { label: "Task", value: props.rowData?.task_desc || "-" },
              {
                label: "Severity",
                value: props.rowData?.severity_desc || "-",
              },
              {
                label: "Uploads",
                value:
                  props.rowData &&
                  Array.isArray(props.rowData.decryptedAttachment) &&
                  props.rowData.decryptedAttachment.length > 0
                    ? props.rowData.decryptedAttachment.length
                    : props.rowData.attachment
                    ? 1
                    : "No ",
              },

              {
                label: "Issue Description",
                value: props.rowData?.tckt_desc || "-",
              },
            ].map((info, index) => (
              <div key={index} className={classes.userDatamap}>
                <Typography variant="body1" className={classes.userDatalabel}>
                  {info.label}:
                </Typography>
                {info.label == "Uploads" ? (
                  <div style={{ display: "flex" }}>
                    <Typography variant="body1" className={classes.uploadLabel}>
                      {info.value + "files"}
                    </Typography>
                    <div>
                      <ArrowDownwardIcon
                        sx={{ color: "grey", cursor: "pointer" }}
                        onClick={(e) => {
                          handleDownload(props.rowData, "createDownload");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <Typography variant="body1" className={classes.uploadValue}>
                    {info.value}
                  </Typography>
                )}
              </div>
            ))}
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={0.2} xl={0.2}></Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={5.5}
          xl={5.5}
          className={classes.cardPacData}
        >
          <div className={classes.cardPacDetails}>
            {[
              { label: "State", value: pacsData?.state_name || "-" },
              { label: "DCCB", value: pacsData?.dccb_code || "-" },
              { label: "District", value: pacsData?.district || "-" },
              { label: "Branch Name", value: pacsData?.branch || "-" },
              { label: "Pac Name", value: pacsData?.dccb_name || "-" },
              { label: "Mandal / Taluka", value: "-" },
              {
                label: "PACS Registered ID",
                value: pacsData?.pacs_id || "-",
              },
              { label: "DCT ID", value: pacsData?.dct_id || "-" },
              { label: "ERP ID", value: pacsData?.erp_id || "-" },
              {
                label: "Site Executive’s Mail Address",
                value: pacsData?.email_id || "-",
              },
              {
                label: "Site Executive’s Mobile Number",
                value: pacsData?.mobile_no || "-",
              },
            ].map((info, index) => (
              <div key={index} className={classes.cardPacMap}>
                <Typography
                  variant="body1"
                  style={{
                    color: "#707EAE",
                    maxWidth: "30%",
                    maxWidth:
                      info.label === "Site Executive’s Mail Address"
                        ? "80%"
                        : "30%",
                    maxWidth:
                      info.label === "Site Executive’s Mobile Number"
                        ? "80%"
                        : "30%",
                    maxWidth: info.label === "Pac Name" ? "20%" : "70%",
                    fontSize: "15px",
                  }}
                >
                  {info.label}:
                </Typography>

                <Typography variant="body1" className={classes.cardPacMapValue}>
                  {info.value}
                </Typography>
              </div>
            ))}
          </div>
        </Grid>
      </Grid>
      <div className={classes.cardPacstatus}>
        Status : {props.rowData.status_dec}
      </div>
      {props.userData &&
        ![8, 9, 10].includes(props.userData.role_id) &&
        allowedRoles.includes(props.userData.role_id) && (
          <div style={{ marginTop: "25px" }}>
            {props.rowData.tckt_status == 7 ||
            props.rowData.tckt_status == 9 ? null : (
              <Grid
                container
                alignItems="stretch"
                spacing={2}
                className={classes.ticketStatus}
              >
                {/* Uploads Section */}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  xl={6}
                  style={{
                    backgroundColor: "#F5F8FF",
                    padding: "10px",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "8px",
                    height: "100px",
                  }}
                >
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={2}
                      lg={2}
                      xl={2}
                      className={classes.uplaods}
                      style={{
                        color: "#707EAE",
                        padding: "10px",
                        fontSize: "16px",
                        alignSelf: "center",
                        marginTop: "16px",
                      }}
                    >
                      Uploads
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      xl={6}
                      style={{ marginTop: "16px" }}
                    >
                      <Input
                        type="text"
                        name="uploadImageupdateddownload"
                        id="uploadImageupdateddownload"
                        borderRadius="8px"
                        backgroundColor="white"
                        color="#707EAE"
                        width="100%"
                        readOnly={true}
                        value={
                          props.rowData &&
                          Array.isArray(
                            props.rowData.decryptedUpdatedAttachment
                          ) &&
                          props.rowData.decryptedUpdatedAttachment.length > 0
                            ? props.rowData.decryptedUpdatedAttachment.length +
                              " file(s)"
                            : props.rowData?.updated_file_name &&
                              props.rowData?.updated_file_extension
                            ? "1 file"
                            : "no file"
                        }
                        downloadIcon={true}
                        handleDownload={() => {
                          handleDownload(props.rowData, "updateDownload");
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Spacer */}
                <Grid item xs={12} sm={12} md={12} lg={0.2} xl={0.2}></Grid>

                {/* Description Section */}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={5.5}
                  lg={5.5}
                  xl={5.5}
                  className={classes.boxCustomRadio}
                  style={{
                    padding: "30px",
                    color: "#707EAE",
                    fontSize: "16px",
                    height: "100px",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "scroll",
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                    wordBreak: "break-all",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>Description:</span>{" "}
                  {props.rowData.reason}
                </Grid>
              </Grid>
            )}
            {([4, 5, 6, 7].includes(props.userData.role_id) &&
              ![2].includes(props.rowData.tckt_status)) ||
            (props.userData.role_id === 3 &&
              ![2, 7, 10].includes(props.rowData.tckt_status)) ||
            ([1, 2].includes(props.userData.role_id) &&
              ![3, 8].includes(props.rowData.tckt_status)) ? (
              <>
                {props.rowData.tckt_status == 3 ||
                props.rowData.tckt_status == 7 ||
                props.rowData.tckt_status == 9 ? null : (
                  <>
                    <Box
                      className={classes.boxCustomRadio1}
                      sx={{
                        gap: 4,
                        // backgroundColor: "#F5F8FF",
                        marginTop: "10px",
                        padding: "5px ",
                      }}
                    >
                      <CustomRadio
                        name="status_ticket"
                        control={control}
                        value={status}
                        color="rgb(131, 145, 190)"
                        register={register("status_ticket", {
                          required: true,
                        })}
                        handleChange={handleChangeStatus}
                        listItems={StatusList}
                      />
                      <div>
                        {errors.status_ticket &&
                          errors.status_ticket.type === "required" && (
                            <ErrorMessage message="Required !!" />
                          )}
                      </div>
                      {status == 8 ||
                      status == 4 ||
                      status == 7 ||
                      status == 2 ? (
                        <Box
                          sx={{
                            gap: 4,
                            backgroundColor: "#F5F8FF",
                            marginTop: "10px",
                          }}
                          ref={targetDivRef}
                        >
                          {status == 4 && props.userData.role_id === 3 && (
                            <div>
                              <div className={classes.userDataRole}>
                                Reassign To{" "}
                                <span style={{ color: "red" }}>*</span>{" "}
                              </div>
                              <CustomSelect
                                name="assgnedTO"
                                control={control}
                                listItems={assignedList}
                                defaultValue=""
                                keyValue="user_id"
                                height="45px"
                                displayValue="user_login"
                                placeholder={"select"}
                                width="100%"
                                required={true}
                              />
                              <div>
                                {errors.assgnedTO &&
                                  errors.assgnedTO.type === "required" && (
                                    <ErrorMessage message="Required !!" />
                                  )}
                                {console.log("ass", errors.assgnedTO)}
                              </div>
                            </div>
                          )}
                          <div>
                            <TextArea
                              required={parseInt(status) !== 7}
                              minRows={4}
                              label={(() => {
                                const statusNum = parseInt(status);
                                switch (statusNum) {
                                  case 8:
                                    return "Reason For Reopen";
                                  case 7:
                                    return "Reason for assigning to intellect";
                                  case 2:
                                    return "Description";

                                  default:
                                    return "Reason for Reassign";
                                }
                              })()}
                              marginTop="4px"
                              placeholder=""
                              width="98%"
                              inputRef={register("reason", {
                                required: parseInt(status) !== 7,
                              })}
                              maxlength={300}
                            />
                            <div>
                              {errors.reason &&
                                errors.reason.type === "required" && (
                                  <ErrorMessage message="Required !!" />
                                )}
                              {console.log("rese", errors.reason)}
                            </div>
                          </div>
                          <Grid
                            container
                            alignItems="center"
                            className={classes.uploadGrid}
                            ticketing_tool         >
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              lg={2}
                              xl={2}
                              className={classes.uploadAttachment}
                            >
                              Upload Attachment
                              {status == 4 ||
                              status == 2 ||
                              status == 8 ||
                              status == 7 ? (
                                ""
                              ) : (
                                <span style={{ color: "red" }}>*</span>
                              )}
                              <span>
                                <Tooltip
                                  title={
                                    status == 7 ||
                                    (status == 8 &&
                                      props?.rowData?.intellect_id !== null)
                                      ? "Note:can upload single File allowed type are zip,jpg,jpeg,png, pdf, docx"
                                      : "Note:Can upload Multliple File allowed type are zip,jpg,jpeg,png, pdf, docx"
                                  }
                                >
                                  <span
                                    style={{
                                      display: "inline-flex",
                                      justifyContent: "center", // Horizontally centers the content
                                    }}
                                  >
                                    <HelpOutlineIcon
                                      style={{
                                        fontSize: "20px",
                                        color: "#707EAE",
                                      }}
                                    />
                                  </span>
                                </Tooltip>
                              </span>
                            </Grid>
                            <Grid item xs={12} sm={5} lg={3} xl={3}>
                              {
                                <input
                                  type="file"
                                  ref={fileInputRef}
                                  name="depmem_attachment"
                                  id="depmem_attachment"
                                  style={{ display: "none" }}
                                />
                              }
                              {
                                <Input
                                  type="file"
                                  name="uploadImage"
                                  id="uploadImage"
                                  borderRadius="8px"
                                  backgroundColor="white"
                                  color="#707EAE"
                                  width="100%"
                                  multiple={
                                    status == 7 ||
                                    (status == 8 &&
                                      props?.rowData?.intellect_id !== null)
                                      ? false
                                      : true
                                  }
                                  inputRef={register("uploadImage", {
                                    required:
                                      status == 4 ||
                                      status == 2 ||
                                      status == 8 ||
                                      status == 7
                                        ? false
                                        : true,
                                    onChange: (e) => handleUploadFile(e),
                                  })}
                                />
                              }
                              <div style={{ marginTop: "3px" }}>
                                {status !== 4 &&
                                  status !== 2 &&
                                  status !== 8 &&
                                  status !== 7 &&
                                  errors.uploadImage &&
                                  errors.uploadImage.type === "required" && (
                                    <ErrorMessage message="Required !!" />
                                  )}
                              </div>
                            </Grid>
                            {props.userData.role_id === 4 ||
                            props.userData.role_id === 5 ||
                            props.userData.role_id === 6 ||
                            props.userData.role_id === 7 ? (
                              <Grid
                                sx={{ marginTop: "15px" }}
                                item
                                xs={12}
                                sm={6}
                                md={6}
                                lg={6}
                                xl={6}
                                style={{ padding: "10px" }}
                              >
                                <Grid container alignItems="center">
                                  <Grid
                                    item
                                    xs={12}
                                    sm={4}
                                    md={4}
                                    lg={4}
                                    xl={4}
                                    style={{ marginRight: "40px" }}
                                  >
                                    <Typography variant="body2" color="#707EAE">
                                      <span style={{marginLeft:"60%"}}>Severity</span>
                                      {/* <span className={classes.labelRequired}>*</span> */}
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={11}
                                    sm={4}
                                    md={4}
                                    lg={4}
                                    xl={4}
                                  >
                                    <CustomSelect
                                      name="severity"
                                      control={control}
                                      listItems={severityData}
                                      displayValue="severity_desc"
                                      keyValue="severity_id"
                                      placeholder="select"
                                      height="45px"
                                      width="100%"
                                      // required={true}
                                      inputRef={register("severity", {
                                        // required: true,
                                      })}
                                    />
                                    <div>
                                      {errors.severity &&
                                        errors.severity.type === "required" && (
                                          <ErrorMessage message="Required !!" />
                                        )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            ) : (
                              ""
                            )}
                          </Grid>
                        </Box>
                      ) : null}
                    </Box>
                  </>
                )}
               

                {props.rowData.tckt_status == 3 ||
                props.rowData.tckt_status == 7 ||props.rowData.tckt_status == 9 ? null : (
                  <div
                    className={classes.updateButton}
                    style={{
                      float: "right",
                      marginTop: "10px",
                      padding: "10px",
                    }}
                  >
                    <ActionButton
                      variant="text"
                      padding="10px 40px"
                      borderRadius="8px"
                      backgroundColor="#0FA5D9"
                      color="white"
                      buttonText="Update"
                      disabled={loading || disableBtn === 1}
                      handleSubmit={handleSubmit(handleUpdateStatus)}
                    />
                  </div>
                )}
              </>
            ) : null}
          </div>
        )}
    </Box>
  );
}

function Detail({ label, value, children }) {
  return (
    <Box sx={{ mb: 1.5 }}>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontWeight: 500 }}
      >
        {label} :
      </Typography>
      <Typography
        variant="body2"
        sx={{ ml: 1, fontWeight: 600, display: "inline" }}
      >
        {value || children}
      </Typography>
    </Box>
  );
}

export default IssueDetails;
